import {useState, useRef, useEffect} from 'react';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import './ImageGallery.css';

function ImageGallery({id, images, imageWidth, imageHeight, onLoad}) {
    const [itemIndex, setItemIndex] = useState(0);
    const [firstImageLoaded, setFirstImageLoaded] = useState(false);
    const slideInterval = useRef(null);

    useEffect(() => {
        return () => {
            stopSlideInterval();
        };
    }, []);

    const onImageLoad = (_status, _image) => {
        const firstImage = images[0];
        if (_image === firstImage) setFirstImageLoaded(true);
    };

    useEffect(() => {
        if (firstImageLoaded && onLoad) {
            onLoad();
            startSlideInterval();
        }
    }, [firstImageLoaded]);

    const startSlideInterval = () => {
        slideInterval.current = setInterval(() => {
            setItemIndex((prevIndex) => {
                let nextIndex = prevIndex + 1;
                if (nextIndex >= images.length) nextIndex = 0;
                return nextIndex;
            });
        }, 3000);
    };

    const stopSlideInterval = () => {
        if (slideInterval.current) {
            clearInterval(slideInterval.current);
            slideInterval.current = null;
        }
    };

    const wrapperStyle = () => {
        return {
            left: `${-itemIndex * 100}%`
        };
    };

    const renderImages = () => {
        if (!images || images.length === 0) return null;
        return images.map((image, index) => (
            <div key={`image-gallery-item-${id}-${index}`} className='image-gallery-item'>
                <ImageWrapper
                    image={image}
                    alt={`gallery-image-${id}-${index}`}
                    display='block'
                    width={imageWidth}
                    height={imageHeight}
                    errorWidth={undefined}
                    errorHeight={undefined}
                    errorPadding={undefined}
                    backgroundColor={undefined}
                    margin={undefined}
                    padding={undefined}
                    borderRadius={undefined}
                    transition={true}
                    loadDelay={0.2}
                    noImageType={undefined}
                    onLoad={onImageLoad}
                />
            </div>
        ));
    };

    return (
        <div className='image-gallery'>
            <div className='image-gallery-wrapper' style={wrapperStyle()}>
                {renderImages(images)}
            </div>
        </div>
    );
};

export default ImageGallery;